module.exports = __webpack_public_path__ + "static/2_1_chicken-crossing-1_HR-59041c09e9dbcdbdce85697ad64ba409.svg";